import { Component, OnInit } from '@angular/core';
import { SiteService } from 'src/app/core/services';
import { SiteContent, HomePageSchema } from '../../../core/schema/index';
import { HOME } from 'src/app/core/data/constants';
import { SafeHtmlUtil } from 'src/app/core/utils';
import { tap } from 'rxjs/operators';

const pageKey = 'homePage';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  [x: string]: any;
  site!: SiteContent;
  loading: boolean = false;
  metadata!: HomePageSchema;

  constructor(private sites: SiteService, public util: SafeHtmlUtil) {}

  async ngOnInit(): Promise<void> {
    this.simLoad();
    await this.getPageContent();
  }

  simLoad(): void {
    this.loading = true;
    setTimeout(() => {
      console.log('simload done...');
    }, 1000);
  }

  async getPageContent(): Promise<void> {
    await this.getMetadata(pageKey)
      .then((res: any) => {
        console.log(`${pageKey} metadata: `);
        console.log(res);
        this.setMetadata(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.site = HOME;
      });
  }

  async getMetadata(metaKey?: string): Promise<any> {
    return await this.sites.getMetadata(`${metaKey || '?q=all'}`)
      .then((metadata: any) => {
        return metadata;
      })
      .catch((err) => {
        console.log(err.message);
        return `Error: ${err.message}`;
      })
      .finally(() => this.loading = false);
  }

  setMetadata(metadata: any): void {
    this.metadata = metadata;
  }
}
